// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.


export const environment = {
  production: false,
  base_url: 'https://pme-dev.sydle.one',
  ecommerce_base_url: window.location.origin,
  api_url: 'https://pme-dev.sydle.one/api/1/portal/',
  // tslint:disable-next-line:max-line-length
  serasaHomePage: 'https://experian-periscope-frontend-uat.test-pme.br.experian.eeca/v2/home',
  api_authorization_token: 'eyJhbGciOiJIUzUxMiJ9.eyJjb2RlIjoiNWUzMDcxMzBjNjMxYjM2YTEyNjEzNjJiIiwibG9naW4iOiJob3RzaXRlIiwibmFtZSI6IkhPVFNJVEUiLCJsb2NhbGUiOiJwdF9CUiIsIl9vcmdJZCI6IjVlMzA1MzQxYzYzMWIzNmExMjYxMzQ4YiIsIl9jbGFzcyI6eyJfaWQiOiIwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDIiLCJfY2xhc3NJZCI6IjAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMCIsImNsYXNzUGFja2FnZUlkZW50aWZpZXIiOiJfc3lzdGVtIiwiY2xhc3NJZGVudGlmaWVyIjoiX2NsYXNzIn0sIl9jcmVhdGlvbkRhdGUiOiIyMDIwLTAxLTI4VDE3OjM2OjQ4LjE5OFoiLCJfbGFzdFVwZGF0ZURhdGUiOiIyMDIwLTAxLTI4VDE3OjM2OjQ4LjE5OFoiLCJfbGFzdFVwZGF0ZVVzZXIiOnsiX2lkIjoiNWUzMDU0NzRjNjMxYjM2YTEyNjEzNWEzIiwiX2NsYXNzSWQiOiIwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDIiLCJjbGFzc1BhY2thZ2VJZGVudGlmaWVyIjoiX3N5c3RlbSIsImNsYXNzSWRlbnRpZmllciI6Il91c2VyIn0sIl9jbGFzc1JldmlzaW9uIjoiNWQ2ZTlmZWE2MDczZjEwYTMxNGJhYWQ0IiwiX3JldmlzaW9uIjoiMTI2NDAyMDQwMyIsImFjdGl2ZSI6dHJ1ZSwib3JnYW5pemF0aW9uSWQiOiJwbWUtZGV2IiwiYXV0aGVudGljYXRpb25DbGFzcyI6Il9zeXN0ZW0uX3VzZXIiLCJ0b2tlblZlcnNpb24iOjE2LCJpc0FwcER5bmFtaWNBdXRoVG9rZW4iOmZhbHNlLCJpYXQiOjE1ODAyMzMwMDgsImlzcyI6Imp3Iiwic3ViIjoiYWNjZXNzVG9rZW4ifQ.dvCqJKXlBcQbaIkVliisPWngDxixFnXjPhtqdRRwbmzCDRbnqssEchZ00-9oYltNqzcChn-QyJ5QUE8XwXtt3A',
  'X-Explorer-Account-Token': 'pme-dev',
  silent_order_enviroment: 'dev',
  dtm_script_url: "//assets.adobedtm.com/launch-EN129773aae4a848b992a4e997bbd571e2-development.min.js",
  sydle_client_id: "5e5ff3d643b20055251dad5c",
  redirect_signature_plan: "https://monitoring-frontend-periscope-serasa-empreendedor-stg.apps.internal.appcanvas.net/v2/assinatura",
  redirect_monitore_plan: "https://monitoring-frontend-periscope-serasa-empreendedor-stg.apps.internal.appcanvas.net/v2/monitore-clientes",
  redirect_consulta: "https://www.serasaempreendedor.com.br/",
  redirect_disconnect_sale: "https://homologa.serasaempreendedor.com.br/",
  one_environment: 'dev',
  adyen_environment: "test",
  datadog_parameters: {
    applicationId: 'e44e8880-6dbb-4e3d-ac04-cf9fe17adddc',
    clientToken: 'pub524a9685a66dddbc318ebd1d336c6213',
    site: 'datadoghq.com',
    service: 'pme---sydle-frontend',
    env: 'uat',
    version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackBfcacheViews: true,
    defaultPrivacyLevel: 'mask-user-input'
  }
};
